import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './open-item.module.scss';
import ItemSecondary from '../ItemSecondary/ItemSecondary';
import { useState } from 'react';
import Link from 'next/link';
import { OpenItemType } from '@/types/header.types';

const OpenItem: NextPage<OpenItemType> = ({
  className = '',
  onClose,
  data,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={[styles.openitem, className].join(' ')}>
      <div
        className={`${styles.sidebarButton} ${isOpen ? styles.active : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <p>{data.title}</p>
        {isOpen ? (
          <Image
            src="/img/header/grayArrowTop.svg"
            alt="Logo Extended"
            width={16}
            height={16}
          />
        ) : (
          <Image
            src="/img/header/grayArrow.svg"
            alt="Logo Extended"
            width={24}
            height={24}
          />
        )}
      </div>
      <div className={`${styles.itemgeneral} ${isOpen ? styles.open : ''}`}>
        <div>
          <Link href={data.href} className={styles.name} onClick={onClose}>
            <span className={styles.goTo}>{`Go to `}</span>
            <span className={styles.about}>{data.title}</span>
            <Image
              className={styles.arrowIcon}
              loading="lazy"
              width={18}
              height={16}
              sizes="100vw"
              alt=""
              src="/img/header/arrowRight.svg"
            />
          </Link>
          <div className={styles.items}>
            {data.subItems.map((item) => (
              <ItemSecondary
                key={item.id}
                chevron="Off"
                state="Default"
                about={item.title}
                onClick={onClose}
                href={item.href}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenItem;
